import React from 'react';
import HeaderComponent from './HeaderComponent';
import LeftNavigation from './LeftNavigation';
import FooterComponent from './FooterComponent';

const WrapperComponent = ({ children }) => {
    return (
        <div style={styles.root}>
            <HeaderComponent />
            <div style={styles.body}>
                <LeftNavigation />
                <main style={styles.content}>
                    {children}
                </main>
            </div>
            <FooterComponent />
        </div>
    );
};

const styles = {
    root: { display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', fontFamily: "'Segoe UI', system-ui, sans-serif" },
    body: { display: 'flex', flex: 1, overflow: 'hidden' },
    content: { flex: 1, overflowY: 'auto', padding: '24px', background: '#f8fafc' },
};

export default WrapperComponent;
